/** Upload progress indicator (T034, port of components/upload_indicator.rs). */

export type UploadState =
  | { kind: 'idle' }
  | { kind: 'reading'; fileName: string }
  | { kind: 'uploading'; progress: number; fileName: string }
  | { kind: 'completed'; sceneKey: string }
  | { kind: 'failed'; step: string; message: string; retryable: boolean }

export function UploadIndicator({ state }: { state: UploadState }) {
  if (state.kind !== 'uploading') return null
  const pct = Math.round(state.progress * 100)
  return (
    <div className="px-3 py-2 bg-card rounded-lg">
      <div className="text-xs text-foreground truncate mb-1">
        {state.fileName}
      </div>
      <div className="w-full bg-muted rounded-full h-1.5">
        <div
          className="bg-muted-foreground h-1.5 rounded-full transition-all"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  )
}
